import KryptonGlue from "./KryptonGlue";

export default KryptonGlue;
